import React from 'react';
import axios from "../../../../../containers/api";
import {showCatchError, toEnglishNumbers} from "../../../../../helpers/Utils";
import {Button, CardBody, Input, Row, Alert, FormGroup, Label, CustomInput} from "reactstrap";
import {Colxx} from "../../../../../components/common/CustomBootstrap";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
class AddProductOwner extends React.Component {
    constructor(props) {
        super(props);
        this.fileUploader = React.createRef();
        this.state = {
            errors: [], 
            firstName: "",
            lastName: "",
            meliCode: "",
            mobile: "",
            file: null, //uploaded picture
            Province: null,
            CityList: [],
            City: null,
            ProvinceList: [],
        }
    }
    componentWillMount() {
        this.loadProvinces();
    }
    loadProvinces = () => {
        this.props.showSpinner();
        axios.get('api/v1/provinces/GetAll')
            .then((res) => {
                this.props.hideSpinner();
                this.setState({ ProvinceList: res.data.data });
            })
            .catch((error) => {
                this.props.hideSpinner();
                this.props.showAlert(showCatchError(error), "error");
                console.log(error.response);
            });
    };

    loadCities = (id) => {
        this.props.showSpinner(); 
        axios.get('api/v1/cities/GetCityByProvinceId/' + id)
            .then((res) => {
                this.props.hideSpinner();
                this.setState({ CityList: res.data.data });
            })
            .catch((error) => {
                this.props.hideSpinner();
                this.props.showAlert(showCatchError(error), "error");
                console.log(error.response);
            });
    };
    validate = () => {
        this.props.closeSweetAlert();
        let error = [];
        if (this.state.firstName.length < 3) {
            error.push('لطفا نام را وارد کنید');
        }
        if (this.state.meliCode.length < 10) {
            error.push('لطفا کد ملی وارد کنید');
        }
        if (this.state.mobile.length < 11) {
            error.push('لطفا موبایل را وارد کنید');
        }
        if (this.state.IsHaghighy === 1 && this.state.lastName < 5) {
            error.push('لطفا نام خانوادگی را وارد کنید');
        }
        if (this.state.file === null) {
            error.push("لطفا فایل مورد نظر را انتخاب کنید");
        }
        if (this.state.City === null || this.state.City === undefined) {
            error.push("انتخاب شهر الزامی میباشد.");
        }
        this.setState({errors: error});
        if (error.length === 0) {
            this.AddProductOwner();
        } else {
            this.props.showAlert("لطفا تمامی اطلاعات درخواست شده را به درستی وارد کنید!", "error");
        }
    };

    AddProductOwner = () => {
        
        let addModel = new FormData();
        addModel.set('Firstname', toEnglishNumbers(this.state.firstName));
        addModel.set('Lastname', toEnglishNumbers(this.state.lastName));
        addModel.set('MeliCode', toEnglishNumbers(this.state.meliCode));
        addModel.set('Mobile', toEnglishNumbers(this.state.mobile));
        addModel.set('CityId', this.state.City !== null ? this.state.City.cityId : null);
        addModel.append('File', this.state.file); 

       

        this.props.showSpinner();
        
        axios.post('/api/v1/product-owners/AddProductOwner', addModel, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }).then((res) => {
                this.props.hideSpinner();
                 
                if (res.data.data.code !== 1 && res.data.data.code !== "1") {
                    this.props.showAlert(res.data.message, "error");
                } else {
                    this.props.showAlert(res.data.message, "success");
                    
                }
            })
            .catch((error) => {
                this.props.hideSpinner();
                console.log(error.response);
                this.props.showAlert(showCatchError(error), "error");
            });
    };

    handleRadioChange = (e, value) => {
        const { name, id } = e.target;
        this.setState({[name]: value});
    };
    selectHandleChange = (event, value, name) => {
        this.setState({ [name]: value },
            () => {
                if (name === "Province") {
                    if (value !== undefined && value !== null) {
                        this.setState({
                            City: null
                        }, () => this.loadCities(value.provinceId));
                    }
                    else {
                        this.setState({
                            City: null, CityList: []
                        })
                    }
                }

            });
    };
    render() {
        return (
            <Row className="d-flex justify-content-center">
                <Colxx md="10" xxs="12">
                    <CardBody className="d-flex flex-column">
                       

                        <div className="d-flex flex-md-row flex-column flex-wrap justify-content-center mt-3">
                            <FormGroup className="w-md-30 w-100 px-1">
                                <Label>*نام</Label>
                                <Input value={this.state.firstName} maxLength={50}
                                       onChange={(e) => this.setState({firstName: e.target.value})}/>
                            </FormGroup>

                           
                                <FormGroup className="w-md-30 w-100 px-1">
                                    <Label>نام خانوادگی</Label>
                                    <Input value={this.state.lastName} maxLength={50}
                                           onChange={(e) => this.setState({lastName: e.target.value})}/>
                            </FormGroup>
                        </div>
                        <div className="d-flex flex-md-row flex-column flex-wrap justify-content-center mt-3">

                            <FormGroup className="w-md-30 w-100 px-1">
                                <Label>*کد ملی</Label>
                                <Input value={this.state.meliCode} maxLength={50}
                                       onChange={(e) => this.setState({meliCode: e.target.value.replace(/[^0-9۰-۹]/g, "")})}/>
                            </FormGroup>

                            <FormGroup className="w-md-30 w-100 px-1">
                                <Label>موبایل</Label>
                                <Input value={this.state.mobile} maxLength={11}
                                       onChange={(e) => this.setState({mobile: e.target.value.replace(/[^0-9۰-۹]/g, "")})}/>
                            </FormGroup>

                            
                        </div>
                        <div className="d-flex flex-md-row flex-column flex-wrap justify-content-center mt-3">
                        <FormGroup className="w-md-30 w-100 px-1">
                            <Label>استان</Label>
                            <Autocomplete
                                clearText={"حذف"}
                                closeText={"بستن"}
                                noOptionsText={"در حال دریافت اطلاعات.."}
                                openText={"باز کردن"}
                                className="react-select__control"
                                id="Province"
                                options={this.state.ProvinceList}
                                getOptionLabel={(option) => option.provinceName}
                                value={this.state.Province}
                                onChange={(e, v) => this.selectHandleChange(e, v, "Province")}
                                renderInput={(params) => (<TextField{...params} variant="standard" />)}
                            />
                        </FormGroup>

                        <FormGroup className="w-md-30 w-100 px-1">
                            <Label>شهر</Label>
                            <Autocomplete
                                clearText={"حذف"}
                                closeText={"بستن"}
                                noOptionsText={"در حال دریافت اطلاعات.."}
                                openText={"باز کردن"}
                                className="react-select__control"
                                id="City"
                                options={this.state.CityList}
                                getOptionLabel={(option) => option.cityName}
                                value={this.state.City}
                                onChange={(e, v) => this.selectHandleChange(e, v, "City")}
                                renderInput={(params) => (<TextField{...params} variant="standard" />)}
                            />
                        </FormGroup>
                        </div>
                        <div className="d-flex flex-md-row flex-column flex-wrap justify-content-center mt-3">
                            <FormGroup className="w-md-25 w-100 mx-1">
                                <label className="form-title">
                                    تصویر</label>

                                <input
                                    style={{ cursor: "cell" }}
                                    className="input" value={this.state.file !== null ? this.state.file.name : "لطفا یک فایل انتخاب کنید"}
                                    onClick={() => this.fileUploader.current.click()} />
                                <input
                                    ref={this.fileUploader}
                                    style={{ display: "none" }} type="file"
                                    onChange={(e) => {
                                        this.setState({ file: e.target.files[0] });
                                    }}
                                />
                            </FormGroup>
                        </div>
                        {this.state.errors.length === 0 ?
                            null
                            :
                            <div>
                                {(this.state.errors.map((error, i) => {
                                    return (
                                        <Alert color="danger" key={i}>{error}</Alert>
                                    )
                                }))}
                            </div>
                        }

                        <div className="d-flex mt-2 justify-content-center">
                            <FormGroup className="text-center">
                                <Button color="primary" className="btn-lg mx-2"
                                        onClick={() => this.props.showSweetAlert("آیا از صحت اطلاعات وارد شده اطمینان دارید؟", "", "warning", this.validate)}>
                                    ثبت
                                </Button>
                            </FormGroup>
                        </div>
                    </CardBody>
                </Colxx>
            </Row>
        );
    }
}

export default AddProductOwner;